import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { HYDRATE } from 'next-redux-wrapper';
// const jsKey = process.env.NEXT_PUBLIC_BAYONET_JS_KEY;

export const bayonetApi = createApi({
  reducerPath: 'bayonetApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `https://fingerprinting.bayonet.io/v2`,
  }),
  extractRehydrationInfo(action, { reducerPath }) {
    if (action.type === HYDRATE) {
      return action.payload[reducerPath];
    }
  },
  tagTypes: ['Bayonet'],
  endpoints: (builder) => ({
    generateFingerprintToken: builder.mutation({
      query: (jsKey) => ({
        url: 'generate-fingerprint-token',
        method: 'POST',
        body: {
          auth: {
            jsKey,
          },
          device: {
            deviceFingerprint: null,
            metadata: {},
          },
        },
      }),
      providesTags: ['BayonetToken'],
    }),
  }),
});

export const { useGenerateFingerprintTokenMutation } = bayonetApi;
